import { Component, Input, OnInit } from "@angular/core";
import { PayableViewModel } from "@tylertech/tyler-api-types";
import { TotalsData } from "./totalsData";
import { KeyValue } from "./keyValue";
@Component({
    selector: "ap-payable-detail",
    templateUrl: "./apPayableDetail.tmpl.html",
    styleUrls: [
        "./apPayableDetail.component.scss"
    ],
    standalone: false
})
export class ApPayableDetailComponent implements OnInit
{
    private _totals = new Map<string, KeyValue<TotalsData>>();

    private _vendors = new Map<string, KeyValue<Array<PayableViewModel>>>();

    count: number;

    @Input()
    detail: Array<PayableViewModel>;

    grandTotal: number;

    get vendors(): Array<KeyValue<Array<PayableViewModel>>>
    {
        return [...this._vendors.values()];
    }

    get totals(): Array<KeyValue<TotalsData>>
    {
        return [...this._totals.values()];
    }

    ngOnInit(): void
    {
        this.detail.forEach(element =>
        {
            if (!this._vendors.has(element.VendorName))
            {
                this._vendors.set(element.VendorName, {
                    key: element.VendorName,
                    value: [],
                });
            }
            this._vendors.get(element.VendorName).value.push(element);
            if (!this._totals.has(element.PayableType))
            {
                this._totals.set(element.PayableType, {
                    key: element.PayableType,
                    value: {
                        count: 0,
                        amount: 0,
                    },
                });
            }
            const total = this._totals.get(element.PayableType);
            total.value.count = total.value.count + 1;
            total.value.amount = total.value.amount + element.TotalAmount;
            this.count = (this.count || 0) + 1;
            this.grandTotal = this.grandTotal + element.TotalAmount;
        });
    }
}
